<h1 matDialogTitle>Terms and Conditions</h1>
<div mat-dialog-content>{{data.text}}</div>
<div mat-dialog-actions class="pt-24">
    <button mat-button (click)="dialogRef.close(false)">OK</button>
</div>